module.exports = __webpack_public_path__ + "img/ptu-4.0bff1011.png";